/**
 * What the assistant settings' "Change name" button puts in a new chat's
 * composer, for the owner to finish with the name they want. Shared so web and
 * native hand the assistant the same request.
 */
export const CHANGE_ASSISTANT_NAME_CHAT_PROMPT = "Change the agent name to ";
